import React from "react";
import Navigation from "../Navigation/Navigation";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { Link } from "react-router-dom";
import failed from "../../assets/t-failed.svg";

const TransactionFailed = () => {
  return (
    <div className="transaction-failed">
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <Navigation />
        </div>
        <div className="main-content pt-3 pr-3 pb-4">
          <p className="page-text dashboard">
            <Link to="/my-profile/subscription/checkOutPage">
              <MdKeyboardArrowLeft className="arrow-left" />
              Back
            </Link>
          </p>
          <div className="successfulPage">
            <img src={failed} alt="failed" className="failed" />
            <h2>Oops, something went wrong!</h2>
            <p>
              We're sorry, but it seems that your transaction couldn't be
              completed at the moment.
            </p>
            <div className="transaction-buttons">
              <Link to="/my-profile/subscription/checkOutPage">
                <button className="purchase-more-button">Retry</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionFailed;
